
import Vue from 'vue';
import { ACTIONS } from '@/constants/actions';
import AuthLayout from '../layouts/AuthLayout.vue';

interface VerifyEmailComponentData {
  verified: boolean;
  error: boolean;
}

export default Vue.extend({
  components: { AuthLayout },
  name: 'VerifyEmail',
  data(): VerifyEmailComponentData {
    return {
      verified: false,
      error: false
    };
  },
  created(): void {
    this.verifyEmailAccount();
  },
  methods: {
    verifyEmailAccount(): void {
      const query = this.$route.query;
      if (query && query.code) {
        const { dispatch } = this.$store;
        dispatch(ACTIONS.profile.verifyEmail, { code: query.code })
          .then(() => {
            this.verified = true;
          })
          .catch(() => {
            this.error = true;
          });
      }
    }
  }
});
